<script>
import { iButton, iIcon } from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';

export default {
  name: 'DocumentRightPanelEmptyState',
  components: { iButton, iIcon },
  props: {
    symbol: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: null,
    },
    buttonText: {
      type: String,
      default: null,
    },
  },
  data() {
    return { palette };
  },

  computed: {},
  methods: {
    onButtonClick() {
      this.$emit('on-button-click');
    },
  },
};
</script>

<template>
  <div
    class="right-panel-empty-state d-flex flex-column align-items-center i-p-10 i-gap-6 i-radius-2xl"
  >
    <i-icon
      :symbol="symbol"
      :size="28"
      :colour="palette['light-neutral-90']"
    ></i-icon>
    <div class="text d-flex flex-column i-gap-1 align-items-center">
      <div class="title i-text-button-3 i-text-neutral-120">{{ title }}</div>
      <div v-if="subTitle" class="subtitle i-text-body-3 i-text-neutral-110">
        {{ subTitle }}
      </div>
    </div>
    <i-button
      v-if="buttonText"
      :text="buttonText"
      type="neutral"
      subtype="subtle"
      size="xs"
      @button-click="onButtonClick()"
    ></i-button>
  </div>
</template>

<style lang="scss" scoped>
.right-panel-empty-state {
  border: 1px solid $light-neutral-60;
}
</style>
